import { Box, Container, Text, Button, Stack, Flex, HStack, Icon } from "@chakra-ui/react";
import React from "react";
import { withTranslation } from "react-i18next";
import { FaArrowRight, FaDownload, FaFacebook, FaInstagram, FaWhatsapp, FaTelegram } from "react-icons/fa";
import { Link } from "react-router-dom";
const CTA = ({ t }) => {
  return (
    <Box
      bgGradient="linear(to-br, #FFD700 0%, #FF7F00 50%, #E65100 100%)"
      py={20}
      position="relative"
      overflow="hidden"
      boxShadow="0 30px 70px rgba(255, 127, 0, 0.4)"
    >
      {/* Background decorative elements */}
      <Box
        position="absolute"
        top="-100px"
        left="-100px"
        w="300px"
        h="300px"
        bg="whiteAlpha.100"
        borderRadius="full"
        filter="blur(60px)"
      />
      <Box
        position="absolute"
        bottom="-50px"
        right="-50px"
        w="200px"
        h="200px"
        bg="whiteAlpha.200"
        borderRadius="full"
        filter="blur(40px)"
      />

      <Container maxW={"container.xl"} position="relative" zIndex={2}>
        <Flex
          direction={{ base: "column", md: "row" }}
          align="center"
          justify="space-between"
          gap={8}
        >
          <Box flex="1" textAlign={{ base: "center", md: "left" }}>
            <Text
              fontSize={{ base: "28px", md: "36px", lg: "42px" }}
              fontWeight="800"
              color="white"
              mb={4}
              lineHeight="1.2"
              fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
              textShadow="0 4px 12px rgba(0,0,0,0.5)"
              filter="drop-shadow(0 2px 4px rgba(0,0,0,0.3))"
            >
              { "ابدأ رحلتك نحو التميز الأكاديمي"}
            </Text>
            <Text
              fontSize={{ base: "16px", md: "18px" }}
              color="white"
              mb={6}
              maxW="500px"
              lineHeight="1.6"
              fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
              textShadow="0 2px 8px rgba(0,0,0,0.4)"
              filter="drop-shadow(0 1px 2px rgba(0,0,0,0.2))"
            >
              { "انضم إلى مجتمع تعليمي متميز مع آلاف الطلاب والمدرسين المختصين. احصل على أفضل المحتوى التعليمي والدعم المستمر لتحقيق أهدافك الأكاديمية"}
            </Text>
          </Box>

          <Stack
            direction={{ base: "column", md: "row" }}
            spacing={4}
            align="center"
          >
            <Link to="/login">
              <Button
                size="lg"
                bg="white"
                color="orange.600"
                _hover={{
                  bg: "orange.50",
                  transform: "translateY(-2px)",
                  boxShadow: "0 8px 25px rgba(0,0,0,0.2)"
                }}
                _active={{ transform: "translateY(0)" }}
                transition="all 0.3s ease"
                rightIcon={<FaArrowRight />}
                px={8}
                py={6}
                fontSize="18px"
                fontWeight="700"
                borderRadius="full"
                boxShadow="0 4px 15px rgba(0,0,0,0.2)"
                fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
              >
                {"ابدأ الآن"}
              </Button>
            </Link>
            <Link to="https://www.facebook.com/groups/755025703589513" target="_blank" rel="noopener noreferrer">
            <Button
              size="lg"
              variant="outline"
              borderColor="white"
              borderWidth="2px"
              color="white"
              _hover={{
                bg: "whiteAlpha.300",
                transform: "translateY(-2px)",
                boxShadow: "0 8px 25px rgba(0,0,0,0.2)"
              }}
              _active={{ transform: "translateY(0)" }}
              transition="all 0.3s ease"
              leftIcon={<FaFacebook />}
              px={8}
              py={6}
              fontSize="18px"
              fontWeight="700"
              borderRadius="full"
              fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
            >
              انضم لمجموعتنا
            </Button>
            </Link>
          </Stack>
        </Flex>

        {/* Social Media Links */}
        <Flex
          direction={{ base: "column", md: "row" }}
          align="center"
          justify="center"
          gap={8}
          mt={12}
        >
          <Text
            fontSize={{ base: "16px", md: "18px" }}
            color="white"
            fontWeight="600"
            fontFamily="'Tajawal', 'Amiri', 'Scheherazade New', 'Noto Sans Arabic', 'Cairo', sans-serif"
            textShadow="0 2px 8px rgba(0,0,0,0.4)"
            filter="drop-shadow(0 1px 2px rgba(0,0,0,0.2))"
          >
            تابعنا على وسائل التواصل الاجتماعي
          </Text>

          <HStack spacing={6} justify="center">
            <Link
              to="https://www.facebook.com/asqueraeg"
              target="_blank"
              rel="noopener noreferrer"
              _hover={{ transform: "translateY(-3px)" }}
              transition="all 0.3s ease"
            >
              <Icon
                as={FaFacebook}
                boxSize={8}
                color="white"
                _hover={{ color: "blue.300" }}
                transition="all 0.3s ease"
              />
            </Link>

            <Link
              to="https://www.instagram.com/asqueraeg"
              target="_blank"
              rel="noopener noreferrer"
              _hover={{ transform: "translateY(-3px)" }}
              transition="all 0.3s ease"
            >
              <Icon
                as={FaInstagram}
                boxSize={8}
                color="white"
                _hover={{ color: "pink.300" }}
                transition="all 0.3s ease"
              />
            </Link>

            <Link
              to="https://wa.me/201500235062"
              target="_blank"
              rel="noopener noreferrer"
              _hover={{ transform: "translateY(-3px)" }}
              transition="all 0.3s ease"
            >
              <Icon
                as={FaWhatsapp}
                boxSize={8}
                color="white"
                _hover={{ color: "green.300" }}
                transition="all 0.3s ease"
              />
            </Link>

            <Link
              to="https://t.me/asquera_system_bot"
              target="_blank"
              rel="noopener noreferrer"
              _hover={{ transform: "translateY(-3px)" }}
              transition="all 0.3s ease"
            >
              <Icon
                as={FaTelegram}
                boxSize={8}
                color="white"
                _hover={{ color: "blue.300" }}
                transition="all 0.3s ease"
              />
            </Link>
          </HStack>
        </Flex>
      </Container>
    </Box>
  );
};

export default withTranslation()(CTA);
